<template>
  <v-container fluid class="pa-0">
    <v-row no-gutters class="contenedor-chat">

      <v-col cols="12" md="4" class="contacts"  v-if="$vuetify.breakpoint.md || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl">
        <v-card class="pa-2 elevation-0" height="100%">
          <v-text-field
            name="name"
            label="Buscar chat"
            v-model="search"
            hide-details
            dense
            :autofocus="buscarUsuarioActive"
            filled
            single-line
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>

          <v-list dense class="overflow-y-auto py-0">
            <v-list-item-group>
              <v-card class="transparent elevation-1">

                <v-card-title primary-title class="text-subtitle-1" >
                  Grupos
                </v-card-title>

                <!-- SECCI*ON DE LOS CONTACTOS -->
                <div
                  id="preguntas"
                >
                  <v-list dense nav >
                    <v-list-item @click="selectedGroup(groups)" >
                      <!-- AVATAR -->
                      <v-list-item-avatar class="avatar-contenedor">
                        <div>{{ groups.campus_name ? cutName(groups.campus_name) : '' }}</div>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <!-- Nombre del contacto -->
                        <v-list-item-title>{{ groups.campus_name }} - {{ groups.level_name }} </v-list-item-title>
                      </v-list-item-content>

                    </v-list-item>
                  </v-list>
                </div>

                <v-divider></v-divider>

                <v-card-title primary-title class="text-subtitle-1">
                  Estudiantes
                </v-card-title>

                <!-- SECCI*ON DE LOS CONTACTOS -->
                <div
                  :style="`height: 350px; overflow: auto;`" 
                  id="preguntas"
                >
                  <v-list dense>
                    <template  v-for="student in groups.students" :kei="student.id">
                      <v-divider inset></v-divider>

                      <v-list-item>
                        <!-- AVATAR -->
                        <v-list-item-avatar>
                          <avataaars v-if="student.avatar != null" :accessoriesType="student.avatar.accessoriesType"
                            :isCircle="true" :clotheType="student.avatar.clotheType" :clotheColor="student.avatar.clotheColor"
                            :eyebrowType="student.avatar.eyebrowType" :eyeType="student.avatar.eyeType"
                            :facialHairColor="student.avatar.facialHairColor" :facialHairType="student.avatar.facialHairType"
                            :graphicType="student.avatar.graphicType" :mouthType="student.avatar.mouthType"
                            :skinColor="student.avatar.skinColor" :topType="student.avatar.topType"
                            :topColor="student.avatar.topColor" :hairColor="student.avatar.hairColor" :circleColor="'#6fb8e0'">
                          </avataaars>
                          <avataaars v-else></avataaars>
                        </v-list-item-avatar>

                        <!-- contenido del contacto -->
                        <v-list-item-content>
                          <!-- Nombre del contacto -->
                          <v-list-item-title v-text="nameCapitalize(student.nombre )"></v-list-item-title>
                        </v-list-item-content>

                      </v-list-item>
                    </template>
                  </v-list>
                </div>

                <v-divider></v-divider>

                <v-card-title primary-title class="text-subtitle-1">
                  Teachers
                </v-card-title>

                <!-- SECCI*ON DE LOS CONTACTOS -->
                <div
                  id="preguntas"
                >
                  <v-list dense>
                    <v-list-item>
                      <v-list-item-avatar class="avatar-contenedor">
                        <div>{{ groups.teachers ? cutName(groups.teachers[0].teacher_nombre) : '' }}</div>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <!-- Nombre del contacto -->
                        <v-list-item-title v-text="groups.teachers ? nameCapitalize(groups.teachers[0].teacher_nombre) : ''"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                      <v-list-item-avatar class="avatar-contenedor">
                        <div>{{ groups.teachers ? cutName(groups.teachers[0].teacher2_nombre) : '' }}</div>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <!-- Nombre del contacto -->
                        <v-list-item-title v-text="groups.teachers ? nameCapitalize(groups.teachers[0].teacher2_nombre) : ''"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </v-card>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>

      <v-navigation-drawer v-model="open" absolute temporary v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm">
        <v-card class="pa-2" height="100%">
          <v-list dense class="overflow-y-auto">
            <v-list-item-group>
              <v-card class="transparent elevation-1">

                <v-card-title primary-title class="text-subtitle-1">
                  Grupos
                </v-card-title>

                <!-- SECCI*ON DE LOS CONTACTOS -->
                <div
                  id="preguntas"
                >
                  <v-list dense nav >
                    <v-list-item @click="selectedGroup(groups)" >
                      <!-- AVATAR -->
                      <v-list-item-avatar class="avatar-contenedor">
                        <div>{{ groups.campus_name ? cutName(groups.campus_name) : '' }}</div>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <!-- Nombre del contacto -->
                        <v-list-item-title>{{ groups.campus_name }} - {{ groups.level_name }} </v-list-item-title>
                      </v-list-item-content>

                    </v-list-item>
                  </v-list>
                </div>

                <v-divider></v-divider>

                <v-card-title primary-title class="text-subtitle-1">
                  Estudiantes
                </v-card-title>

                <!-- SECCI*ON DE LOS CONTACTOS -->
                <div
                  :style="`height: 350px; overflow: auto;`" 
                  id="preguntas"
                >
                  <v-list dense>
                    <template  v-for="student in groups.students" :kei="student.id">
                      <v-divider inset></v-divider>

                      <v-list-item>
                        <!-- AVATAR -->
                        <v-list-item-avatar>
                          <avataaars v-if="student.avatar != null" :accessoriesType="student.avatar.accessoriesType"
                            :isCircle="true" :clotheType="student.avatar.clotheType" :clotheColor="student.avatar.clotheColor"
                            :eyebrowType="student.avatar.eyebrowType" :eyeType="student.avatar.eyeType"
                            :facialHairColor="student.avatar.facialHairColor" :facialHairType="student.avatar.facialHairType"
                            :graphicType="student.avatar.graphicType" :mouthType="student.avatar.mouthType"
                            :skinColor="student.avatar.skinColor" :topType="student.avatar.topType"
                            :topColor="student.avatar.topColor" :hairColor="student.avatar.hairColor" :circleColor="'#6fb8e0'">
                          </avataaars>
                          <avataaars v-else></avataaars>
                        </v-list-item-avatar>

                        <!-- contenido del contacto -->
                        <v-list-item-content>
                          <!-- Nombre del contacto -->
                          <v-list-item-title v-text="nameCapitalize(student.nombre )"></v-list-item-title>
                        </v-list-item-content>

                      </v-list-item>
                    </template>
                  </v-list>
                </div>

                <v-divider></v-divider>

                <v-card-title primary-title class="text-subtitle-1">
                  Teachers
                </v-card-title>

                <!-- SECCI*ON DE LOS CONTACTOS -->
                <div
                  id="preguntas"
                >
                  <v-list dense>
                    <v-list-item>
                      <v-list-item-avatar class="avatar-contenedor">
                        <div>{{ groups.teachers ? cutName(groups.teachers[0].teacher_nombre) : '' }}</div>
                      </v-list-item-avatar>
                      <div>{{ groups.teachers ? nameCapitalize(groups.teachers[0].teacher_nombre) : '' }}</div>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-avatar class="avatar-contenedor">
                        <div>{{ groups.teachers ? cutName(groups.teachers[0].teacher2_nombre) : '' }}</div>
                      </v-list-item-avatar>
                      <div>{{ groups.teachers ? nameCapitalize(groups.teachers[0].teacher2_nombre) : '' }}</div>
                    </v-list-item>
                  </v-list>
                </div>
              </v-card>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-navigation-drawer>

      <v-col cols="12" md="8">

        <v-card v-if="groupSelected.length === 0" class="pa-2 elevation-0" color="#f0f2f5" height="100%">
          <v-card-title class="chat-header">
            <v-row no-gutters>
              <v-col cols="3">
                <v-img :src="selectedUser.avatar" class="mr-2 chat-avatar rounded-circle"> </v-img>
              </v-col>
              <v-col cols="6">
                <h5 class="mb-0 chat-name">{{ selectedUser.name }}</h5>
                <p class="grey--text chat-status">{{ selectedUser.status }}</p>
              </v-col>
              <v-col cols="2">
                <v-app-bar-nav-icon class="btn-burguer" @click="showContacts" v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm">
                </v-app-bar-nav-icon>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text class="no-chat">
            <h2>No se ha seleccionado ningún chat</h2>
            <p>Da clic en algún chat o contacto</p>
          </v-card-text>
        </v-card>



        <v-card v-else class="elevation-0" height="100%">

          <v-toolbar
            class="elevation-0"
            dense
            color="#f0f2f5"
          >
            <v-list-item-avatar class="avatar-contenedor">
              <div>{{ groupSelected.campus_name ? cutName(groupSelected.campus_name) : '' }}</div>
            </v-list-item-avatar>
            {{ `${groupSelected.campus_name} - ${groupSelected.level_name}` }}

            <v-spacer></v-spacer>
            <v-app-bar-nav-icon class="btn-burguer" @click="showContacts" v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm"></v-app-bar-nav-icon>
          </v-toolbar>

          <section class="chat">
            <div 
              class="messages-chat" 
              :style="`max-height: 1000px; overflow: auto;`" 
              id="mensajesChat"
            >
              <div id="scroll">
                <div>
                  <div>
                    <span v-for="(messageGroup, posicion) in messages" :key="posicion">
                      <div class="message text-only mb-8">


                        <div :class="`${ messageGroup.user_id === getDatosUsuarioLMS.id_usuario ? 'response' : 'noresponse' }`">
                        
                          <p 
                            v-if="messageGroup.user_id != getDatosUsuarioLMS.id_usuario"
                            :class="`${ messageGroup.user_id != getDatosUsuarioLMS.id_usuario ? 'time' : 'response-time time'} black--text`"
                          >{{ userName( messageGroup.user_id ) }}</p>

                          <!-- Menú de opciones -->
                          <v-menu offset-y >
                            
                            <template v-slot:activator="{ on, attrs }" >
                              <v-btn
                                v-if="messageGroup.user_id === getDatosUsuarioLMS.id_usuario || messageGroup.file_name !== null"
                                :class="messageGroup.user_id === getDatosUsuarioLMS.id_usuario ? 'response' : 'noresponse'"
                                icon 
                                v-bind="attrs" 
                                v-on="on"
                              >
                                <v-icon>
                                  mdi mdi-chevron-down
                                </v-icon>
                              </v-btn>
                            </template>
                            
                            <v-list class="item-menu" >
                              <v-list-item 
                                class="menu-item"
                                v-for="(item, index) in items" 
                                :key="index" 
                                link
                                :class="index === 1 && messageGroup.file_name || index === 0 && messageGroup.user_id === getDatosUsuarioLMS.id_usuario ? 'd-block' : 'd-none'"
                              >
                                <v-list-item-title
                                  :class="index === 0 && messageGroup.user_id === getDatosUsuarioLMS.id_usuario ? 'd-block' : 'd-none'"
                                  @click="abrirModalEliminarMensaje(messageGroup)"
                                >
                                  {{ item.title }}
                                </v-list-item-title>
                                
                                <v-list-item-title 
                                  :class="index === 1 && messageGroup.file_name ? 'd-block' : 'd-none'"
                                  @click="descargarAdjunto(posicion)"
                                >
                                  {{ item.title }}
                                </v-list-item-title>
                              
                              </v-list-item>
                            </v-list>
                            
                          </v-menu>

                          <!-- Visualizar una imagen -->
                          <p 
                            class="text" 
                            v-if=" ['.png', '.apng', '.jpeg', '.svg', '.gif'].includes( messageGroup.filename_extension ) "
                            style="white-space: pre-line"
                            @click="verImagen( messageGroup.file_name )"
                            type="button"
                          >
                            <v-img :src="url + messageGroup.file_name" alt="Red dot" max-width="300" style="border-radius: 10px;"/>

                            <span><br/>{{ messageGroup.message.includes('$archivo') ? '' : messageGroup.message }}</span>
                          </p>

                          <!-- Visualizar puro texto  -->
                          <p 
                            class="text" 
                            v-if="messageGroup.filename_extension === null"
                            style="white-space: pre-line"
                          >
                            {{ messageGroup.message }}
                          </p>

                          <!-- VISUALIZAR UN PDF -->
                          <p 
                            class="text" 
                            v-if="messageGroup.filename_extension === '.pdf'"
                            style="white-space: pre-line"
                          >
                            <a target="_blank" :href="url + messageGroup.file_name" ref="download" download></a>

                            <object 
                              :data="url + messageGroup.file_name" 
                              type="application/pdf" 
                              width="200" 
                              height="200" 
                              @click="verPDF( messageGroup )"
                              style="border-radius: 10px;"
                            >
                              <p>No se pudo cargar la vista previa del archivo PDF.</p>
                            </object>
                            
                            <span><br/>{{ messageGroup.message.includes('$archivo') ? '' : messageGroup.message }}</span>
                          </p>

                          
                          <p 
                            :class="`${ !messageGroup.user_id === getDatosUsuarioLMS.id_usuario ? 'time' : 'response-time time'} black--text`"
                          >{{ convertDate(messageGroup.created_at) }}</p>
                        </div>
                      </div>
                    </span>
                  </div>
                

                </div>
              </div>
            </div>
            <!-- Sección para enviar un mensaje -->
            <div id="sectionMessage" style="background: #f0f2f5; padding: 5px; padding-top: 10px; padding-bottom: 10px; padding-right: 15px;">

              <v-row no-gutters>
                <v-col cols="auto">
                  <v-file-input 
                    :max-size="1048576" 
                    v-model="archivoAdjunto" 
                    show-size 
                    hide-details
                    prepend-icon="mdi-paperclip" 
                    single-line
                    @change="mostrarPrevisualizacion" 
                    @click:clear="clearMessage"
                  >
                  </v-file-input>
                  
                  <v-btn 
                    @click="mostrarModal = true" 
                    v-if="previsualizacion" 
                    text
                  >
                    Ver previsualización
                  </v-btn>
                </v-col>
                
                <v-col>
                  <v-textarea
                    absolute
                    label="Escribe un mensaje aquí"
                    solo
                    hide-details
                    single-line
                    dense
                    auto-grow
                    rows="2"
                    v-model="messageObject.message"
                    :append-outer-icon="messageObject.message ? 'mdi-send' : ''"
                    @click:prepend="adjuntarArchivo"
                    @click:append-outer="sendMessage"
                    @keyup.enter="sendMessage"
                  ></v-textarea>
                </v-col>
              </v-row>
            </div>
          </section>

          <ModalArchivoGrande ref="modalArchivoGrande" />

        </v-card>
      </v-col>
    </v-row>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />

    <v-dialog v-model="dialog" max-width="300">
      <v-card>
        <v-card-title class="text-h5">
          ¿Deseas eliminar este mensaje?
        </v-card-title>

        <v-card-text>
          Los mensajes eliminados ya no se pueden deshacer
        </v-card-text>

        <v-card-actions>

          <v-btn color="black" dark tile small @click="dialog = false">
            <v-icon left small>mdi-cancel</v-icon>
            Cancelar
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn color="primary" dark tile small @click="eliminarMensaje">
            <v-icon left small>mdi-check</v-icon>
            Si, eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="mostrarModal" max-width="500">
      <v-card>
        <v-card-text class="px-0">
          <div v-if="tipoArchivo ? ['application/pdf', 'image/jpeg', , 'image/png', , 'image/jpg'].includes( tipoArchivo.type ) : null" >

            <!-- Objeto para cuando es PDF -->
            <v-card-title v-if="tipoArchivo ? tipoArchivo.type.includes('pdf') : null">
              <object :data="previsualizacion + '#toolbar=0'" type="application/pdf" width="100%"
                height="500px">
              </object>
            </v-card-title>
            
            <!-- Para cuando es imagen  -->
            <div v-else>
              <img :src="previsualizacion" alt="Previsualización" style="max-width: 100%">
            </div>

          </div>

          <!-- Alerta de cuando es un archivo no valido, que no es pdf o imagen  -->
          <div v-else>
            <div align="center" class="mx-auto d-flex flex-column align-center" max-width="400">
              <v-card-title class="text-h5">
                Error, archivo no válido
              </v-card-title>
              <v-card-text>
                <v-icon large color="red">mdi-file-alert-outline</v-icon>
              </v-card-text>
            </div>
          </div>

          
          <!-- Botones de mensaje -->
          <v-text-field 
            class="mx-4"
            v-if="tipoArchivo ? ['application/pdf', 'image/jpeg', , 'image/png', , 'image/jpg'].includes( tipoArchivo.type) : null"
            filled 
            clear-icon="mdi-close-circle" 
            clearable
            label="Escribe un mensaje" 
            type="text" 
            @keyup.enter="sendMessage"
            v-model="messageObject.message"
            append-outer-icon="mdi-send"
            @click:append-outer="sendMessage"
            hide-details
          >
          </v-text-field>
        
        </v-card-text>
        
        <!-- Botones para enviar o cerrar -->
        <v-card-actions>
          <v-btn color="secondary" @click="clearMessage" block tile>Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog para ver imágenes -->
    <v-dialog v-model="dialgImagen" max-width="600px" persistent :fullscreen="fullscreen">
      <v-card class="elevation-0">
        <v-card-text>
          <!-- Imagen -->
          <v-img :src="url + imagen" contain aspect-ratio="2">
          </v-img>
        </v-card-text>
          <!-- Guardar la información  -->
          <v-btn
            color="primary" 
            dark 
            icon
            absolute
            top
            right
            class="elevation-6" 
            large 
            @click="dialgImagen = false"
          ><v-icon>mdi-close</v-icon></v-btn>
      </v-card>
    </v-dialog>

    <!-- VER PDF -->
    <v-dialog v-model="dialogPDF" max-width="650px" persistent>
      <v-card class="elevation-0">
        <!-- Imagen -->
        <embed :src="url + pdf" width="650" height="700" type="application/pdf" v-if="wha">
        <v-card-actions class="pt-0" >
          <v-spacer></v-spacer>
          <!-- Guardar la información  -->
          <v-btn
            color="error" 
            dark 
            class="elevation-6" 
            block
            @click="dialogPDF = false"
          >Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>
<script>
import dayjs from 'dayjs'
import { es } from 'dayjs/locale/es'
import { mapGetters } from 'vuex'
import avataaars from 'vuejs-avataaars'
import io from 'socket.io-client'
import ModalArchivoGrande from '@/components/chat/ModalArchivoGrande.vue'
import Alerta from '@/components/alertas/Alerta.vue'

export default {
  name: 'ChatComponent',
  components: { avataaars, ModalArchivoGrande, Alerta },

  data() {
    return {
      open: false,
      socket: null,
      respuestaAlerta: false,
      parametros: {
        dialogError: false,
        mensaje: '',
        color: ''
      },
      download: null,
      tipoArchivo: null,
      mostrarModal: false,
      modalArchivoGrande: null,
      modalEliminar: null,
      mensajeModal: '',
      previsualizacion: null,
      url: this.$http.options.root + 'chat-files/',
      archivoAdjunto: null,
      messages: [],
      groups: [],
      modalOpen: false,
      groupSelected: [],
      messageObject: {
        message: '',
        filename_extension: undefined,
        file: undefined
      },
      messageContainer: null,
      show: false,
      mensajeEliminar: {},
      dialog: false,
      attachmentFile: false,
      message: false,
      marker: true,
      iconIndex: 0,
      items: [
        { title: 'Eliminar mensaje' },
        { title: 'Descargar' },
      ],
      selectedUser: {},
      search: '',
      newMessage: '',
      buscarUsuario:'',
      buscarUsuarioActive: true,

      dialogArchivos: false,
      archivos:null,
      vistaPrevia: null,
      file: '',
      dragging: false,
      dialgImagen:false,
      fullscreen: false,
      pdf:null,
      dialogPDF: false,
      
      imagen: null,
      wha: {}
    }
  },
  computed: {
    ...mapGetters('login', ['getDatosUsuarioLMS', 'getGrupos']),
  },
  methods: {
    loadGroupData(data) {
      this.socket.emit('join_group', data)
      this.socket.on('join_group', data => {
        if (data) {
          this.socket.emit('load_group_data', { limit: 100, offset: 2 })
          this.socket.on('load_group_data', data => {
            console.log(data)
            this.groups = data.group_data
            this.messages = data.messages
          })
        }
      })
    },
    mostrarPrevisualizacion(event) {
      if (this.archivoAdjunto && this.archivoAdjunto.size > 1048576) {
        this.$refs.modalArchivoGrande.abrir(true)
        this.archivoAdjunto = null
        this.archivoGrande = true
        this.clearMessage()
        return

      }
      const archivoSeleccionado = event
      this.tipoArchivo = archivoSeleccionado
      console.log(this.tipoArchivo)
      console.log(archivoSeleccionado)
      if (!archivoSeleccionado) {
        return;
      }
      this.previsualizacion = URL.createObjectURL(archivoSeleccionado);
    },
    convertDate(date) {
      return dayjs(date).locale('es').format('DD/MMMM/YYYY h:mm A')
    },
    cutName(name) {
      return `${name.split(' ')[0].charAt(0).toUpperCase()}${name.split(' ')[1].charAt(0).toUpperCase()}`
    },
    nameCapitalize(name) {
      return name.toLowerCase().split(' ').map(nameCut => nameCut.charAt(0).toUpperCase() + nameCut.slice(1)).join(' ')
    },
    userName(id) {
      console.log( id )
      const name = this.groups.students.find(user => user.id == id)
      return this.nameCapitalize(name.nombre)
    },
    selectedGroup(group) {
      this.groupSelected = group
      this.open = false
      setTimeout(function(){document.getElementById('mensajesChat').scrollTop=document.getElementById('mensajesChat').scrollHeight},500);
      console.log(group)
    },
    showContacts() {
      this.open = !this.open
    },
    usuarioSeleccionado(user) {
      this.selectedUser = user
      this.open = false
    },
    descargarAdjunto(posicion) {
      console.log(posicion)
      this.$refs.download[posicion].click()
    },
    abrirModalEliminarMensaje(message) {
      // this.$refs.modalEliminar.abrir(message)
      this.mensajeEliminar = message
      this.dialog = true
    },
    eliminarMensaje() {
      this.socket.emit('delete_message', { message_id: this.mensajeEliminar._id });
      this.dialog = false
    },

    adjuntarArchivo() {
      this.$refs.adjuntarArchivo.click()
    },

    sendMessage() {
      if (this.messageObject.message !== '' || this.archivoAdjunto) {

        if (this.messageObject.message !== '' && this.archivoAdjunto === null) {

          this.socket.emit('message_channel', this.messageObject)
          this.clearMessage()
          return
        }

        if (this.archivoAdjunto !== null && this.messageObject.message !== '') {
          this.messageObject.filename_extension = this.archivoAdjunto.type
          this.messageObject.file = this.archivoAdjunto
          this.socket.emit('message_channel', this.messageObject)
          console.log('estoy aqui tambien')

          this.clearMessage()
          return

        }
        if (this.archivoAdjunto !== null && this.messageObject.message === '') {
          this.messageObject.message = '$archivo'
          this.messageObject.filename_extension = this.archivoAdjunto.type
          this.messageObject.file = this.archivoAdjunto
          this.socket.emit('message_channel', this.messageObject)
          console.log('estoy aqui tambien')
          this.clearMessage()
          return
        }

      }

    },
    toggleMarker() {
      this.marker = !this.marker
    },
    clearMessage() {
      this.archivoAdjunto = null
      this.messageObject = {
        message: '',
        filename_extension: undefined,
        file: undefined
      }
      this.previsualizacion = null
      this.mostrarModal = false
    },
    resetIcon() {
      this.iconIndex = 0
    },

    getColorIcon( chat ){
      return 'primary'
    },

    getNombre( texto ){
      return texto
    },

    cancelar( ){
      this.vistaPrevia        = null
      this.archivos           = null
      this.file               = '';
      this.dialogArchivos     = false
    },

    getBase64(file) {
      var me = this
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        me.vistaPrevia = {
          url: reader.result, 
          image_name: file.name
        }
      };
    },
 
    onChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        this.dragging = false;
        return;
      }
      
      this.createFile(files[0]);
    },

    createFile(file) {
      if (file.size > 40000000) {
        alert('please check file size no over 40 MB.')
        this.dragging = false;
        return;
      }
      
      this.file = file;
      this.getBase64(this.file)
      this.dragging = false;
    },

    verImagen( value ){
      this.imagen      = value
      this.dialgImagen = true
    },

    verPDF( value ){
      console.log( value )
      this.pdf         = value.file_name
      this.dialogPDF   = true
    },

  },
  watch: {
    previsualizacion(valor) {
      if (valor) {
        this.mostrarModal = true
      }
    }
  },
  mounted() {
    this.socket = io('ws://localhost:3001/', { transports: ['websocket'] })

    this.loadGroupData({ group_id: this.getGrupos[this.getGrupos.length - 1]?.id, user_id: this.getDatosUsuarioLMS.id_usuario })

    this.socket.on('disconnect', (data) => {
      if (data) {
        this.respuestaAlerta = true
        this.parametros.mensaje = 'Desconectado del servidor, por favor recarga la aplicación'
        this.parametros.dialogError = true
        this.parametros.color = '#FF2C2C'
      }
    })

    this.socket.on('delete_message', (messageDeleted) => {
      this.messages = this.messages.filter(message => message._id !== messageDeleted.message_removed._id)
    })
    this.socket.on('message_channel', (message) => {

      console.log(message)
      this.messages = [...this.messages, message]
      this.$nextTick(() => {
        document.getElementById('mensajesChat').scrollTop=document.getElementById('mensajesChat').scrollHeight
      })

    })

  }
}
</script>
  
<style scoped>

  .avatar-contenedor {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #00275F;
    color: #fff;
    font-weight: bold;
  }

  .download {
    display: none;
  }

  .overflow-y-auto {
    overflow-y: auto;
  }

  .avatar-group {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #6fb8e0;
    color: #fff;
    font-weight: bold;
  }

  .no-chat {
    height: 80%;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    text-align: center;
  }

  .contenedor-chat {
    height: 90vh; 
  }

  .input-message {
    height: 80px;
  }

  .btn-opciones {
    background-color: white;
  }

  .item-menu {
    padding: 0;
    /* height: 48px; */
  }

  .menu-item {
    padding: 10px;
  }

  .chat-name {
    font-size: 15px;
  }

  .btn-burguer {
    display: block;
  }

  .chat-avatar {
    width: 60px;
  }

  #sectionMessage{
    position: absolute;
    top: 86vh;
    left: 0px;
    width: 100%;
    background-color: #e9edef;
    padding: 10px;
  }

  #preguntas::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > #preguntas::-webkit-scrollbar:vertical {
    width: 4px !important;
  }

  #preguntas::-webkit-scrollbar:vertical{
    width: 4px !important;
  }

  #preguntas::-webkit-scrollbar-button:increment,#preguntas::-webkit-scrollbar-button{
    display: none;
  }

  #preguntas::-webkit-scrollbar:horizontal{
    display: none;
  }

  #preguntas::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }

  /**********************************/

  #mensajesChat{
    height: 90vh;
  }

  #mensajesChat::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > #mensajesChat::-webkit-scrollbar:vertical {
    width: 4px !important;
  }

  #mensajesChat::-webkit-scrollbar:vertical{
    width: 4px !important;
  }

  #mensajesChat::-webkit-scrollbar-button:increment,#mensajesChat::-webkit-scrollbar-button{
    display: none;
  }

  #mensajesChat::-webkit-scrollbar:horizontal{
    display: none;
  }

  #mensajesChat::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }

  /* ===== MENU ===== */
  .menu {
    float: left;
    height: 700px;;
    width: 70px;
    background: #4768b5;
    background: -webkit-linear-gradient(#4768b5, #35488e);
    background: -o-linear-gradient(#4768b5, #35488e);
    background: -moz-linear-gradient(#4768b5, #35488e);
    background: linear-gradient(#4768b5, #35488e);
    box-shadow: 0 10px 20px rgba(0,0,0,0.19);
  }

  .menu .items {
    list-style:none;
    margin: auto;
    padding: 0;
  }

  .menu .items .item {
    height: 70px;
    border-bottom: 1px solid #6780cc;
    display:flex;
    justify-content: center;
    align-items: center;
    color: #9fb5ef;
    font-size: 17pt;
  }

  .menu .items .item-active {
    background-color:#5172c3;
    color: #FFF;
  }

  .menu .items .item:hover {
    cursor: pointer;
    background-color: #4f6ebd;
    color: #cfe5ff;
  }

  /* === CONVERSATIONS === */
  .desc-contact {
    height: 43px;
    width:50%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .timer {
    margin-left: 15%;
    font-family:'Open Sans', sans-serif;
    font-size: 11px;
    padding: 3px 8px;
    color: #BBB;
    background-color: #FFF;
    border: 1px solid #E5E5E5;
    border-radius: 15px;
  }

  .chat {
    width: calc(100%);
  }

  .chat .messages-chat {
    padding: 25px 10px;
  }

  .chat .messages-chat .message {
    display:flex;
    align-items: center;
    margin-bottom: 2px;
  }

  .chat .messages-chat .message .photo {
    display: block;
    width: 45px;
    height: 45px;
    background: #E6E7ED;
    -moz-border-radius: 50px;
    -webkit-border-radius: 50px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .chat .messages-chat .text {
    margin: 0 35px;
    background-color: #fff;
    padding: 15px;
    border-radius: 12px;
  }


  .text-only {
    white-space: pre-line;
  }

  .time {
    font-size: 12px;
    color:lightgrey;
    margin-bottom:10px;
    margin-left: 38px;
  }

  .response-time {
    float: right;
    margin-right: 40px !important;
  }

  .response {
    float: right;
    margin-right: 0px !important;
    margin-left: auto; /* flexbox alignment rule */
    max-width: 90%;
  }

  .noresponse {
    max-width: 90%;
  }

  .audio {
    background-color: #f1f3f4 !important;
  }

  .response .audio {
    background-color: #f1f3f4 !important;
  }

  .footer-chat {
    width: calc(65% - 66px);
    height: 80px;
    display:flex;
    align-items: center;
    position:absolute;
    bottom: 0;
    background-color: transparent;
    border-top: 2px solid #EEE;

  }

  .chat .footer-chat .icon {
    margin-left: 30px;
    color:#C0C0C0;
    font-size: 14pt;
  }

  .chat .footer-chat .send {
    color:#fff;
    background-color: #4f6ebd;
    position: absolute;
    right: 50px;
    padding: 12px 12px 12px 12px;
    border-radius: 50px;
    font-size: 14pt;
  }

  .chat .footer-chat .name {
    margin: 0 0 0 20px;
    text-transform: uppercase;
    font-family:'Montserrat', sans-serif;
    font-size: 13pt;
    color:#515151;
  }

  .chat .footer-chat .right {
    position: absolute;
    right: 40px;
  }

  .dropZone {
    width: 80%;
    height: 150px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone:hover {
    border: 2px solid #D8D8D8;
  }

  .dropZone:hover .dropZone-title {
    color: #1975A0;
  }

  .dropZone-info {
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  ..dropZone-title {
    color: #787878;
  }

  .dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .dropZone-upload-limit-info {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  }

  .dropZone-over {
    background: #D8D8D8;
    opacity: 0.8;
  }

  .dropZone-uploaded {
    width: 80%;
    height: 200px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone-uploaded-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #D8D8D8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .removeFile {
    width: 200px;
  }
  
  #mensajesChat{
    background-image: url("@/assets/fondo_whatsapp.jpg");
    background-repeat: repeat-y;
    background-repeat: repeat-x;
    background-size:contain;
  }

  /* ===== MENU ===== */
  .menu {
    float: left;
    width: 70px;
    background: #4768b5;
    background: -webkit-linear-gradient(#4768b5, #35488e);
    background: -o-linear-gradient(#4768b5, #35488e);
    background: -moz-linear-gradient(#4768b5, #35488e);
    background: linear-gradient(#4768b5, #35488e);
    box-shadow: 0 10px 20px rgba(0,0,0,0.19);
  }

  .menu .items {
    list-style:none;
    margin: auto;
    padding: 0;
  }

  .menu .items .item {
    height: 70px;
    border-bottom: 1px solid #6780cc;
    display:flex;
    justify-content: center;
    align-items: center;
    color: #9fb5ef;
    font-size: 17pt;
  }

  .menu .items .item-active {
    background-color:#5172c3;
    color: #FFF;
  }

  .menu .items .item:hover {
    cursor: pointer;
    background-color: #4f6ebd;
    color: #cfe5ff;
  }

  /* === CONVERSATIONS === */
  .timer {
    margin-left: 15%;
    font-family:'Open Sans', sans-serif;
    font-size: 11px;
    padding: 3px 8px;
    color: #BBB;
    background-color: #FFF;
    border: 1px solid #E5E5E5;
    border-radius: 15px;
  }

  .chat {
    width: calc(100%);
  }

  .chat .messages-chat {
    padding: 25px 10px;
  }

  .chat .messages-chat .message {
    display:flex;
    align-items: center;
    margin-bottom: 2px;
  }

  .chat .messages-chat .message .photo {
    display: block;
    width: 45px;
    height: 45px;
    background: #E6E7ED;
    -moz-border-radius: 50px;
    -webkit-border-radius: 50px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .chat .messages-chat .text {
    margin: 0 35px;
    background-color: #fff;
    padding: 15px;
    border-radius: 12px;
  }

  .text-only {
    white-space: pre-line;
  }

  .time {
    font-size: 12px;
    color:lightgrey;
    margin-bottom:10px;
    margin-left: 38px;
  }

  .response-time {
    float: right;
    margin-right: 40px !important;
  }

  .response {
    float: right;
    margin-right: 0px !important;
    margin-left: auto; /* flexbox alignment rule */
    max-width: 90%;
  }

  .noresponse {
    max-width: 90%;
  }

  .response .text {
    background-color: #DCF8C6 !important;
    color: black;
  }

  .footer-chat {
    width: calc(65% - 66px);
    height: 80px;
    display:flex;
    align-items: center;
    position:absolute;
    bottom: 0;
    background-color: transparent;
    border-top: 2px solid #EEE;
    
  }

  .chat .footer-chat .icon {
    margin-left: 30px;
    color:#C0C0C0;
    font-size: 14pt;
  }

  .chat .footer-chat .send {
    color:#fff;
    background-color: #4f6ebd;
    position: absolute;
    right: 50px;
    padding: 12px 12px 12px 12px;
    border-radius: 50px;
    font-size: 14pt;
  }

  .chat .footer-chat .name {
    margin: 0 0 0 20px;
    text-transform: uppercase;
    font-family:'Montserrat', sans-serif;
    font-size: 13pt;
    color:#515151;
  }

  .chat .footer-chat .right {
    position: absolute;
    right: 40px;
  }

</style>


  